import React from 'react';
import logoPilari from '../assets/images/pilari_light.png';
import logoGZW from '../assets/images/gzw.png';
import { FileLock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300 py-24 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-3xl shadow-xl overflow-hidden transition-colors duration-300">

        {/* Hero */}
        <div className="relative h-[320px] sm:h-[400px]">
          <img
            src={require('../assets/images/cikuray.webp')}
            alt="Gunung Cikuray"
            className="absolute inset-0 w-full h-full object-cover brightness-75"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
            <img src={logoPilari} alt="Logo PILARI" className="w-20 sm:w-24 mb-3 drop-shadow-md" />
            <h1 className="text-3xl sm:text-4xl font-bold drop-shadow-lg">
              {t('privacy.title')}
            </h1>
            <p className="text-sm sm:text-base font-medium drop-shadow-sm mt-2">
              {t('privacy.subtitle')}
            </p>
          </div>
        </div>

        {/* Konten */}
        <div className="p-8 space-y-8 text-sm sm:text-base leading-relaxed text-gray-700 dark:text-gray-200">
          {/* Intro */}
          <section>
            <h2 className="text-lg font-semibold text-green-700 dark:text-green-400 flex items-center gap-2 mb-2">
              <FileLock className="w-5 h-5" />
              {t('privacy.heading')}
            </h2>
            <p>{t('privacy.intro')}</p>
          </section>

          {/* Sections */}
          {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
            <section key={n}>
              <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-1">
                {t(`privacy.s${n}.title`)}
              </h3>
              {Array.isArray(t(`privacy.s${n}.content`, { returnObjects: true }))
                ? (
                  <ul className="list-disc list-inside space-y-1">
                    {t(`privacy.s${n}.content`, { returnObjects: true }).map((line, idx) => (
                      <li key={idx}>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{t(`privacy.s${n}.content`)}</p>
                )}
            </section>
          ))}

          <p className="text-xs text-gray-500 dark:text-gray-400">{t('privacy.updated')}</p>
        </div>

        {/* Footer */}
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 text-center py-4">
          <div className="inline-flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <span>{t('privacy.footer')}</span>
            <img src={logoGZW} alt="Garut Zero Waste" className="h-8" />
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
